<template>
  <div class="d-flex-column justify-start align-start gap-8">
    <div class="d-flex-row justify-start gap-5">
      <label for="" class="t-light regular-l font-family-2">
        {{ $t("extra_gold") }}
      </label>
      <ItemTooltip :text="$t('extra_gold_desc')" />
    </div>
    <DropDown
      :item-key="'gold'"
      :drop-items="keyedGoldOption"
      :select-drop-item="selectItem"
      :make-unsorted="false"
      :selected-item="checkoutStore.getPackExtraOptions['gold']"
      v-if="!$isMobile() && !$isTablet()"
    />
    <BSPicker
      v-else-if="$isMobile() || $isTablet()"
      :title="$t('extra_gold')"
      :show-title="false"
      :items="keyedGoldOption"
      item-key="id"
      :selected-item="checkoutStore.getPackExtraOptions['gold']"
      :select-filter="selectItem"
      :allow-null="false"
      filter-key="gold"
    />
  </div>
</template>

<script setup>
import ItemTooltip from "../../fc-25/pickers/ItemTooltip.vue";
import ValueSetter from "../../commonpickers/ValueSetter.vue";
import DropDown from "~/components/custom/DropDown.vue";
import BSPicker from "./BSPicker.vue";

const gameStore = useGameStore();
const checkoutStore = useCheckoutStore();

const value = ref(1);
const min = ref(1);
const max = ref(1800000);

const keyedGoldOption = computed(() => {
  const extraOptions = gameStore.getGamePack.pack_extra_options?.filter(
    (op) => op.description === "gold_selector"
  );
  if (extraOptions.length > 0) {
    return extraOptions?.reduce((accumulator, value) => {
      return {
        ...accumulator,
        [value.id]: `<span class='t-white'>${
          value.title?.split(" Extra Gold")[0]
        }</span> <span class='t-blue text-capitalize'>${renderPrice(
          value
        )}</span>`,
      };
    }, {});
  }
  return {};
});
const selectItem = (key, value) => {
  const intVal = parseInt(value);
  if (checkoutStore.getPackExtraOptions[key] === intVal) {
    delete checkoutStore.getPackExtraOptions[key];
  } else {
    checkoutStore.setPackExtraOptions({
      [key]: intVal,
    });
  }
};

const renderPrice = (packOption) => {
  if (packOption.type === "free") {
    return packOption.type;
  } else if (packOption.type === "variable") {
    return `+${packOption.price}%`;
  } else if (packOption.type === "fixed") {
    return `+${packOption.price}$`;
  } else {
    return `+${packOption.price}`;
  }
};
</script>

<style lang="scss" scoped>
.gold_container {
  width: 100%;
  padding: 12px;
  background-color: #0e1012;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 12px;
  .select_gold {
    width: 100%;
    height: auto;
    object-fit: contain;
    max-width: 57px;
    transform: skew(-100%);
  }
}
</style>
